module.exports = __webpack_public_path__ + "img/rocket-02.0c1ea02e.svg";